import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";

const SkuUsageSchema = z.object({
  sku: z.string(),
  products: z.array(
    z.object({
      productId: productIdFormat.schema,
      productFamilyId: productFamilyIdFormat.schema,
      title: z.string(),
    }),
  ),
});
export type SkuUsage = z.infer<typeof SkuUsageSchema>;

export const checkSkuAvailability = {
  name: "checkSkuAvailability" as const,
  input: z.object({
    skus: z.array(z.string()).max(500),
    /** Exclude products from this product family (since those are expected) */
    excludeProductFamilyId: productFamilyIdFormat.schema.optional(),
  }),
  output: z.object({
    /** SKUs in use by other products, with details about which products */
    usedSkus: z.array(SkuUsageSchema),
  }),
};
